
<template>
  <div class="red--text ">
    <v-col>
      <v-container class="">
        <!-- <v-img class="ma-7 mb-0" contain max-height="45vh" :src="logoCheckbits"></v-img> -->

        <div class="pa-3 headline white--text text-center" > 
          <div class="mb-10 mt-n3 font-weight-bold">
          Uh-oh! Essa página não foi encontrada
          </div>
          <v-btn class="mt-10" color="error" small @click="$router.push('/')" rounded><v-icon left>mdi-arrow-left</v-icon>voltar</v-btn>
        </div>
        <div class="mb-10 mt-15 font-weight-normal text-center white--text">
          Se você acha que está vendo isso por engano, entre em contato com nosso time de suporte em 
          <a href="mailto:contato@fusiontecnologia.com" class="font-weight-bold gtxt"> contato@fusiontecnologia.com </a>
        </div>
      </v-container>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
// import logo from "@/assets/logo_checkbits.png";
// import logoErr from "@/assets/404.png";

export default {
  data() {
    return {
      key: null,
      // logoCheckbits: logoErr

    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>
body {
  background-color: white !important;
}
.gtxt {
  color: #1dd3bd;
}
</style>